module.exports = __webpack_public_path__ + "static/media/53355843_2452990924776084_8254003763598065664_o.f01f4bf5.jpg";